import { Component, Input } from "@angular/core";

@Component({
  selector: "overview-view-engine-tap",
  templateUrl: "./overview-view-engine.component.html"
})

export class OverViewComponent {
  @Input() overviewAtt;
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/modals/view-engine/tabs/over-view/overview-view-engine.component.ts